/**
 * Utilitários para limpeza de cache
 */

import { avatarCacheService } from '../services/avatarCacheService';
import { imageCacheService } from '../services/imageCacheService';

/**
 * Inicializa a limpeza de cache da aplicação
 * Deve ser chamado quando a aplicação iniciar
 */
export const initializeCacheCleanup = () => {
  // Limpar avatares expirados
  avatarCacheService.cleanExpiredAvatars();
  
  // Limpar cache a cada 6 horas
  setInterval(() => {
    avatarCacheService.cleanExpiredAvatars();
    // O imageCacheService já tem limpeza automática interna
  }, 6 * 60 * 60 * 1000); // 6 horas

  // Log de estatísticas do cache (apenas em desenvolvimento)
  if (process.env.NODE_ENV === 'development') {
    setInterval(() => {
      const stats = imageCacheService.getCacheStats();
    }, 30 * 60 * 1000); // A cada 30 minutos
  }
};
